module.exports = __webpack_public_path__ + "static/alte-haas-bold-98ada20ce5c3c2df629c35bfcef6add2.woff2";